export default {
      id: "ic_lieu_date-usage",
      viewBox: "0 0 15 15",
      url: "../dist/images/" + "sprite.svg#ic_lieu_date-usage",
      toString: function () {
        return this.url;
      }
    }